import { Utilities, ModalAction } from '../Utility/Utilities';
import * as toastr from "toastr";
import * as events from '../Bus/Bus';
import { FeatureType, IAPIResult, ICAMSKey, TextPack } from '../Models/UtilityModels';
import { EventBus } from 'ts-bus';
import { ContactListConfig, ICAMSContact } from '../Contacts/ContactsModels';
import { Photos } from '../Photos/Photos';
import { ModalPrompts, PredefinedModalEnum } from '../Utility/ModalPrompts';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    CAMSMainPage_LeftPanels = '#CAMSMainPage_LeftPanels',
    CAMSMainPage_RightPanels = '#CAMSMainPage_RightPanels',
    CAMSMainToolbar_Container = '#CAMSMainToolbar_Container',
    officerMapContainer = '#officerMapContainer',

    headerMenuLoggedInUserID = '#headerMenuLoggedInUserID',
    _layoutHeaderNotifationListIcon = '#_layoutHeaderNotifationListIcon',
    notificationListGoToNotificationManagerBtn = '#notificationListGoToNotificationManagerBtn',
    notificationListFilter = '#notificationListFilter',
    notificationListShowingStartBtn = '#notificationListShowingStartBtn',
    notificationListShowing = '#notificationListShowing',
    notificationListShowingEndBtn = '#notificationListShowingEndBtn',
    notificationListShowingNextBtn = '#notificationListShowingNextBtn',
    notificationListShowingPrevBtn = '#notificationListShowingPrevBtn',
    notificationPanelContainer = '#notificationPanelContainer',
    readerModal = '#readerModal',
    notificationListCloseBtn = '#notificationListCloseBtn',
    notificationListRecordCount = '#notificationListRecordCount',
    notificationQueryModal = '#notificationQueryModal',
    notificationQueryForm = '#notificationQueryForm',
    notificationQueryCancelBtn = '#notificationQueryCancelBtn',
    notificationQuerySubmitBtn = '#notificationQuerySubmitBtn',
    notificationQueryView_contactSearch = '#notificationQueryView_contactSearch'
}

// Exported models 
export enum NotificationListType {
    AssignedTo,
    RecordedBy,
    MyActivities,
    MaintNotification,
    InfraNotification,
    RouteNotification,
    LandNotification,
    TaskNotification,
    TaskGroupNotification
}

export class NotificationListRequestModel {
    Skip: number;
    Take: number;
}

export enum NotificationListFilter {
    All
}


export class NotificationDataContextIdModel {
    code: string;
    UID: number;
    featureType: FeatureType;
}

export class Notification {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private issueMaxNumberInList: number = 10;
    private issueCountFromServer: number = 0;
    private currentPage: number = 0;
    private notificationListRequestModel: NotificationListRequestModel;
    private photos: Photos = new Photos();
    private intervalTimerMS = 30000;

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this; 

        // Bind the main bell icon on the toolbar
        Utilities.GetControl(jqc._layoutHeaderNotifationListIcon).on("click", function () {
            let model: NotificationListRequestModel = { Skip: 0, Take: 0 };
            self.openNotificationListPanel(model);
        });

        // Bind the goto manager btn
        Utilities.GetControl(jqc.notificationListGoToNotificationManagerBtn).on("click", function () { window.location.href = '/notifications'; });
        
        // Form changes
        Utilities.GetControl(jqc.notificationListFilter).on('change', function () { self.notificationListFilterSelected(); });
        $('#notificationListPageAmount select').on('change', function () { self.notificationListPageAmountSelected(); });

        // Paging buttons
        Utilities.GetControl(jqc.notificationListShowingStartBtn).on("click", function () {
            self.currentPage = 0;
            this.blur();
            self.GetActivitiesFromServer();
            Utilities.GetControl(jqc.notificationListShowing).html((self.currentPage + 1).toString());
        });

        Utilities.GetControl(jqc.notificationListShowingEndBtn).on("click", function () {
            self.currentPage = Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList);
            this.blur();
            self.GetActivitiesFromServer();
            Utilities.GetControl(jqc.notificationListShowing).html((self.currentPage + 1).toString());
        });
        Utilities.GetControl(jqc.notificationListShowingNextBtn).on("click", function () {
            if (self.currentPage == Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList)) return;

            self.currentPage++;
            this.blur();
            self.GetActivitiesFromServer();
            Utilities.GetControl(jqc.notificationListShowing).html((self.currentPage + 1).toString());
        });
        Utilities.GetControl(jqc.notificationListShowingPrevBtn).on("click", function () {
            if (self.currentPage == 0) return;
            self.currentPage--;
            this.blur();
            self.GetActivitiesFromServer();
            Utilities.GetControl(jqc.notificationListShowing).html((self.currentPage + 1).toString());
        });

        //************************************************************ */
        // Switching this off
        // Set an interval to check for new notifications
        //setInterval(function () { self.GetUnreadNotificationCount(); }, self.intervalTimerMS)
        //self.GetUnreadNotificationCount(); // Get first one right away
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openNotificationListPanel = (model: NotificationListRequestModel): void => {
        this.notificationListRequestModel = model;
        Utilities.GetControl(jqc.notificationPanelContainer).addClass("show");
        this.resetPage();

        this.GetActivitiesFromServer();
    }

    public openNotificationDetailsPanel = (notificationID: number): void => {
        Utilities.BlockUI();
        let url = "Notifications/ViewInAppNotificationPartial/" + notificationID;
        Utilities.GetControl(jqc.placeholder_for_modals).load(url, function (response, status, xhr) {
            Utilities.UnBlockUI();
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            Utilities.GetModal(jqc.readerModal, ModalAction.Create);
            let readerModelIframe = $("#readerModalIframe");
            if (readerModelIframe[0] != undefined) {
                let readerModelIframeContent = readerModelIframe[0].dataset.content;
                readerModelIframe[0].setAttribute("src", getBlobURL(readerModelIframeContent, 'text/html'));
            }
          
            function getBlobURL (code, type) {
                const blob = new Blob([code], { type })
                return URL.createObjectURL(blob)
            }
        });
    }

    public openNotificationQueryPanel = (data: ICAMSKey, callback: Function): void => {
        const self = this;
        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_modals).load('/Notification/NotificationQueryView', { EntityCode: data.code, FeatureType: data.featureType }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.notificationQueryModal, ModalAction.Create);

            Utilities.GetControl(jqc.notificationQueryView_contactSearch).on('click', function () {
                function callback(c: Array<ICAMSContact>) {
                    Utilities.GetModal(jqc.notificationQueryModal, ModalAction.Show);
                    Utilities.UpdateContactTypeDropDown($(jqc.notificationQueryModal + ' [name="AssignedTo"]'), c[0].ContactType, c[0].ContactRef);
                }

                // Open the contacts list view
                Utilities.GetModal(jqc.notificationQueryModal, ModalAction.Hide);

                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));
            });

            //initialise photo uploader
            self.photos.setupUploader(jqc.notificationQueryModal);

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.notificationQueryModal));

            Utilities.GetControl(jqc.notificationQuerySubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.notificationQueryForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                

                if ($(jqc.notificationQueryModal + ' [name="AssignedTo"]').val()!="") {
                    ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.NotificationQuery }).then(r => {
                        if (r.yes == true) {
                            $(jqc.notificationQueryModal + ' [name="SendNotification"]').val('true');
                            submitForm();
                        }
                        else {
                            $(jqc.notificationQueryModal + ' [name="SendNotification"]').val('false');
                            submitForm();
                        }
                    }).catch(e => { });
                }
                else {
                    submitForm();
                }

                function submitForm() {
                    Utilities.BlockUI();
                    let formData = new FormData(<any>Utilities.GetControl(jqc.notificationQueryForm)[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: '/Notification/AddQuery',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    toastr.info('Query sent!')
                                }
                                else {
                                    toastr.error('Failed to send query!')
                                }
                                if (callback != null) callback(result.success);
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                                if (callback != null) callback(false);
                            }
                            finally {
                                Utilities.UnBlockUI();
                                Utilities.GetModal(jqc.notificationQueryModal, ModalAction.Hide);
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }
            });

            Utilities.GetControl(jqc.notificationQueryCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.notificationQueryModal, ModalAction.Hide);
            });
        });
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public GetActivitiesFromServer = (el = $('#notificationListDataContainer')): void => {
        const self = this;

        // Get the new count
        this.GetNotificationCount();

        var model = this.notificationListRequestModel;
        model.Skip = self.currentPage * self.issueMaxNumberInList;
        model.Take = self.issueMaxNumberInList;

        Utilities.BlockUI(el);
        el.load('/Notification/NotificationList', model, function (response, status, xhr) {
            Utilities.UnBlockUI(el);
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            // Bind buttons
            Utilities.GetControl(jqc.notificationListCloseBtn).on('click', function () {
                events.bus.publish(events.eventResetRightPanels());
            });

            // Bind rows
            $('[data-notificationid]').on("click", function () {
                let notificationID = $(this).data("notificationid");
                self.openNotificationDetailsPanel(notificationID);
                $.get('/Notification/MarkAsRead/' + notificationID);
                $(this).removeClass("notificationHasNotRead");
                $(this).addClass("notificationHasRead");
            });

            // Bind rows
            $('[data-model]').on("click", function (evt) {
                evt.stopPropagation();
                Utilities.GetModal('#placeholder-for-modals .modal', ModalAction.Hide);

                let data: NotificationDataContextIdModel = $(this).data("model");
                let camsKey: ICAMSKey = { code: data.code, featureType: data.featureType, uid: data.UID };
                if (data.featureType == FeatureType.Maint) {
                    events.bus.publish(events.eventOpenMaintEditPanel(camsKey));
                }
                else if (data.featureType == FeatureType.Activity) {
                    events.bus.publish(events.eventOpenActivityDetailsPanel([data.UID, null]));
                }
                else if (data.featureType == FeatureType.Task) {
                    events.bus.publish(events.eventOpenTasksEditPanel([camsKey, null]));
                }
                else if (data.featureType == FeatureType.TaskGroup) {
                    events.bus.publish(events.eventOpenTaskGroupEditPanel(camsKey));
                }
                else if (data.featureType == FeatureType.LegalEvent) {
                    events.bus.publish(events.eventOpenLegalEventsEditPanel(camsKey));
                }
                else if (data.featureType == FeatureType.LegalConsultation) {
                    events.bus.publish(events.eventOpenLegalConsultationDetailsPanel(camsKey));
                }
                else {
                    toastr.error("The notification cannot open this type of entity: "+data.featureType);
                }
            });

        });
    }

    private GetNotificationCount = (): void => {
        // Get the data from the server
        const self = this;
        $.get('/Notification/NotificationListCount', function (response) {
            try {
                self.issueCountFromServer = JSON.parse(response);
                if (self.issueCountFromServer > 0) {
                    Utilities.GetControl(jqc.notificationListRecordCount).html(' (' + self.issueCountFromServer + ')');
                }
                else {
                    Utilities.GetControl(jqc.notificationListRecordCount).html();
                }
            }
            catch (e) {
                console.log("Error getting issue data: getCount");
                console.log(e);
            }
        }).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetUnreadNotificationCount = (): void => {
        var loggedInUserEl = Utilities.GetControl(jqc.headerMenuLoggedInUserID);
        if (loggedInUserEl[0] == null) return; // Do not get the count if the user is not logged in

        // Get the data from the server
        const self = this;
        $.get('/Notification/NotificationUnreadCount', function (response) {
            try {
                var count = JSON.parse(response);
                if (count > 9) {
                    $('#_layoutHeaderNotifationListIcon .badge').html("9+");
                }
                else if (count > 0) {
                    $('#_layoutHeaderNotifationListIcon .badge').html(count);
                }
                else {
                    $('#_layoutHeaderNotifationListIcon .badge').html("");
                }
            }
            catch (e) {
                console.log("Error getting issue data: NotificationUnreadCount");
                console.log(e);
            }
        }).fail(function (xhr) {
            
        });
    }

    // ----------------------------------------------------------- //
    // ON SELECT CHANGE
    private notificationListFilterSelected = (): void => {
        // Reset the page
        this.resetPage();
        this.GetActivitiesFromServer();
    }

    private notificationListPageAmountSelected = (): void => {
        this.issueMaxNumberInList = $('#notificationListPageAmount select').children("option:selected").val() as number;
        this.GetActivitiesFromServer();
    }

    // ----------------------------------------------------------- //
    // MISC
    private resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.issueCountFromServer = 0;
        this.updatePagingUI();
    }

    private updatePagingUI = (): void => {
        const self = this;
        if (self.issueCountFromServer > 0) { $('#recordCount').html(' (' + self.issueCountFromServer + ')'); } else { $('#recordCountIndividual').html(); }
        Utilities.GetControl(jqc.notificationListShowing).html((self.currentPage + 1).toString());
    }
}




